import { render } from "./MessageSigner.vue?vue&type=template&id=a087bb0a&scoped=true"
import script from "./MessageSigner.vue?vue&type=script&lang=js"
export * from "./MessageSigner.vue?vue&type=script&lang=js"

import "./MessageSigner.vue?vue&type=style&index=0&id=a087bb0a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a087bb0a"]])

export default __exports__